var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgICircleSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2566_22881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.75C3.86429 0.75 0.5 4.11429 0.5 8.25C0.5 12.3857 3.86429 15.75 8 15.75C12.1357 15.75 15.5 12.3857 15.5 8.25C15.5 4.11429 12.1357 0.75 8 0.75ZM8 14.6786C4.45486 14.6786 1.57143 11.7951 1.57143 8.25C1.57143 4.70486 4.45486 1.82143 8 1.82143C11.5451 1.82143 14.4286 4.70486 14.4286 8.25C14.4286 11.7951 11.5451 14.6786 8 14.6786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3662 5.97306L7.29465 9.04459L5.96418 7.71411C5.73711 7.48704 5.37077 7.48704 5.14369 7.71411C4.91662 7.94118 4.91662 8.30752 5.14369 8.5346L6.88476 10.2757C6.99794 10.3888 7.14666 10.4454 7.29536 10.4454C7.44408 10.4454 7.5928 10.3888 7.70596 10.2757L11.1881 6.79353C11.4152 6.56645 11.4152 6.20011 11.1881 5.97304C10.961 5.74597 10.5947 5.74597 10.3676 5.97304L10.3662 5.97306Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2566_22881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICircleSuccess);
export default __webpack_public_path__ + "static/media/i-circle-success.42a350fbd21f0b6680ddd772381fca9a.svg";
export { ForwardRef as ReactComponent };